import React from "react";
import KC_UIText from "../../../../../designsystem/typography/KC_UIText/KC_UIText";
import { KC_Weights } from "../../../../../designsystem/ds_commons";
import KC_UISmall from "../../../../../designsystem/typography/KC_UITextSmall/KC_UISmall";
import { tt } from "../../../../../utils/i18n/i18n";
import { ExpiryType } from "kadow-jetpack-model";

interface ExpiryDelaySelectorProps {
  idx?: number;
  basePath?: string;
  value: number;
  setFieldValue: (
    field: string,
    value: ExpiryType,
    shouldValidate?: boolean
  ) => void;
}

const ExpiryDelaySelector: React.FC<ExpiryDelaySelectorProps> = ({
  idx,
  basePath,
  value,
  setFieldValue
}) => {
  const prefix = basePath ?? `prizes[${idx}]`;

  const handleChange = (e: any) => {
    const val = parseInt(e.target.value);
    if (isNaN(val)) {
      return;
    }

    if (val) {
      setFieldValue(`${prefix}.expiry`, {
        method: "relative",
        value: val
      });
    } else {
      setFieldValue(`${prefix}.expiry`, {
        method: "none",
        value: 0
      });
    }
  };

  return (
    <div className="d-flex flex-column" id="expiry-delay-selector">
      <label>
        <KC_UIText
          weight={KC_Weights.bold}
          text={tt("gift_expiry_delay_label")}
        />
      </label>
      <div className="d-flex align-items-center gap-sm">
        <select
          className="form-control kc-input-wrapper"
          value={value}
          onChange={handleChange}
        >
          {EXPIRY_DELAYS.map((ed) => {
            return (
              <option
                key={ed.value}
                value={ed.value}
                selected={ed.value == value}
              >
                {/* @ts-ignore  */}
                {tt(ed.nameKey)}
              </option>
            );
          })}
        </select>
      </div>
      <KC_UISmall
        className="text-secondary mt-1"
        weight={KC_Weights.reg}
        text={tt("gift_expiry_reminder_text")}
      />
    </div>
  );
};

export default ExpiryDelaySelector;

const EXPIRY_DELAYS = [
  {
    value: 0,
    nameKey: "expiry_delay_disabled"
  },
  {
    value: 1,
    nameKey: "until_tomorrow"
  },
  {
    value: 12 * 3600,
    nameKey: "expiry_delay_12_hours"
  },
  {
    value: 86400,
    nameKey: "expiry_delay_1_day"
  },
  {
    value: 86400 * 7,
    nameKey: "expiry_delay_1_week"
  },
  {
    value: 86400 * 14,
    nameKey: "expiry_delay_2_weeks"
  },
  {
    value: 86400 * 21,
    nameKey: "expiry_delay_3_weeks"
  },
  {
    value: 86400 * 30,
    nameKey: "expiry_delay_1_month"
  },
  {
    value: 86400 * 2 * 30,
    nameKey: "expiry_delay_2_months"
  },
  {
    value: 86400 * 3 * 30,
    nameKey: "expiry_delay_3_months"
  },
  {
    value: 86400 * 6 * 30,
    nameKey: "expiry_delay_6_months"
  },
  {
    value: 86400 * 12 * 30,
    nameKey: "expiry_delay_12_months"
  }
];
